module.exports = __webpack_public_path__ + "static/media/feature7.23ff8a45.png";